import { CardStatus } from '@seapoint/server/enums';
import { exhaustiveCheck } from '../../../utils/exhaustive-check';

export const getStatusLabel = (status: CardStatus) => {
  switch (status) {
    case CardStatus.ACTIVE:
      return 'Active';
    case CardStatus.BLOCKED:
    case CardStatus.SUSPENDED:
      return 'Frozen';
    case CardStatus.CANCELLED:
      return 'Cancelled';
    case CardStatus.EXPIRED:
      return 'Expired';
    case CardStatus.CREATED:
      return 'Created';
    default:
      return exhaustiveCheck(status);
  }
};
